@defer (when taskDetails() && !isLoadingTaskDetail()) {
  @let _taskDetails = taskDetails()!;
  @if (_taskDetails) {
    <div class="task-detail relative border flex flex-col h-full">
      <ui-goback-to-list class="border-b-2" (goBackToList)="goBackToAllTaskList()" />

      <div class="task-detail__content flex-1 overflow-y-auto">
        <div class="task-detail__header">
          <div class="task-detail__header-title p-4">
            <a
              href="#"
              class="task-detail__title link-text flex w-full font-semibold !whitespace-normal mb-4"
              data-testid="task-item__view"
              (click)="$event.preventDefault()"
              [innerHTML]="_taskDetails?.title"
            >
            </a>
          </div>
          <div class="task-detail__header-content flex flex-col gap-2 p-4">
            <wcg-task-header
              [title]="_taskDetails?.title"
              [status]="_taskDetails?.status"
              (viewQuestion)="viewQuestion()"
              (changeStatus)="changeStatus($event)"
            >
              <div taskHeaderContent>
                @if (
                  _taskDetails?.task_type === "document_type_required" &&
                  _taskDetails.status === "new_task"
                ) {
                  <ng-container
                    [ngTemplateOutlet]="uploadButtonTemplate"
                    [ngTemplateOutletContext]="{ $implicit: _taskDetails }"
                  />
                }
              </div>
            </wcg-task-header>
          </div>
          @if (_taskDetails?.active_assignee) {
            <ng-container
              [ngTemplateOutlet]="asigneeInfoTemplate"
              [ngTemplateOutletContext]="{
                task: _taskDetails!,
              }"
            />
          }
        </div>
        <div class="task-detail__description flex flex-col gap-4 border-t">
          <div class="task-detail__description-text text-md text-gray-700">
            <ng-container
              [ngTemplateOutlet]="timestampTemplate"
              [ngTemplateOutletContext]="{ task: _taskDetails! }"
            />

            <p [innerHTML]="_taskDetails?.description"></p>
          </div>
          <ng-container
            [ngTemplateOutlet]="infotemplate"
            [ngTemplateOutletContext]="{
              displayName: 'Team',
            }"
          />

          @for (
            group of $groupedDocuments();
            track group.timestamp + "-" + group.author
          ) {
            <div
              class="task-detail__document-group border-t pt-6 text-md text-gray-700"
            >
              <ng-container
                [ngTemplateOutlet]="timestampTemplate"
                [ngTemplateOutletContext]="{
                  task: _taskDetails!,
                  customTimestamp: group.timestamp,
                }"
              />

              <div class="task-detail__document-content flex flex-col gap-1">
                <wcg-banner icon="check_circle" class="mb-4">
                  Uploaded<br />
                  @for (doc of group.documents; track doc.id) {
                    <a
                      href="#"
                      class="task-detail__document-link link-text"
                      (click)="viewDocument(doc.id); $event.preventDefault()"
                      data-testid="task-item__document-link"
                    >
                      {{ doc.title }}
                    </a>
                  }
                </wcg-banner>

                <ng-container
                  [ngTemplateOutlet]="infotemplate"
                  [ngTemplateOutletContext]="{
                    displayName: group.author,
                  }"
                />
              </div>
            </div>
          }
        </div>
      </div>

      @if ($isMessagingEnabled()) {
        <div class="task-detail__footer mt-auto border-t bg-white">
          <!-- Task Messaging Component -->
          <wcg-task-messaging />
        </div>
      }
    </div>
  }
}
<ng-template
  #timestampTemplate
  let-task="task"
  let-customTimestamp="customTimestamp"
>
  <div class="task-detail__timestamp flex justify-between text-gray-500 mb-1">
    <span
      class="task-detail__timestamp-text text-[1.2rem] text-gray-500 font-semibold"
      >{{
        customTimestamp
          ? (customTimestamp | ermDateTime)
          : (task.created_dt | ermDateTime)
      }}</span
    >
  </div>
</ng-template>
<ng-template #infotemplate let-task="task" let-displayName="displayName">
  <div
    class="task-detail__info flex justify-end items-center text-gray-500 mb-1"
  >
    <img
      src="assets/logo-wcg.svg"
      alt="WCG"
      class="task-detail__logo h-6 w-auto"
    />
    @if (displayName) {
      <span class="task-detail__info-name font-semibold">{{
        displayName
      }}</span>
    }
  </div>
</ng-template>

<ng-template #asigneeInfoTemplate let-task="task">
  <div
    class="task-detail__assignee flex justify-between items-center mt-2 border-t border-b border-gray-300 p-4"
  >
    <div class="task-detail__assignee-content flex items-center gap-1">
      @if (task.active_assignee) {
        <ui-assignee [assignee]="task.active_assignee" />
      }
    </div>
  </div>
</ng-template>
<ng-template #uploadButtonTemplate let-task>
  <wcg-button
    data-testid="task-item__upload-documents"
    color="tertiary"
    size="slim"
    (click)="uploadTaskDocument()"
  >
    <mat-icon fontSet="material-symbols-outlined">upload</mat-icon>
    Upload Document
  </wcg-button>
</ng-template>

